import { render, staticRenderFns } from "./select-clients.vue?vue&type=template&id=45c0cb86&scoped=true&lang=pug&"
import script from "./select-clients.vue?vue&type=script&lang=ts&"
export * from "./select-clients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c0cb86",
  null
  
)

export default component.exports